import RequestService from '../../services/request.service';
import ViewError from '../../../components/ViewError';
import moment from 'moment';
import CustomDateRangePicker from '../../../physical/components/date-range-picker/DateRangePicker';
import {DATE_RANGE_CONFIG} from '../../../physical/enums/date-range.config';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import CustomTable from '../../components/custom-table/CustomTable';
import Datepicker from 'vuejs-datepicker';
import {uk} from 'vuejs-datepicker/dist/locale';
import EmailModalLegal from "../../components/email-modal/EmailModal";
import Vue from "vue";

export default {
  components: {
    EmailModalLegal,
    CustomDateRangePicker,
    Datepicker,
    ViewError,
    CustomTable
  },
  data() {
    return {
      loading: true,
      isCheckbox: true,
      opacity: '1',
      initData: {},
      requestData: {},
      elements: [],
      additionalElements: null,
      elementName: '',
      all_accounts: 'not_all_selected',
      table: null,
      tabs: null,
      selectAccounts: [],
      errors: {},
      dateStart: '',
      dateFinish: '',
      config: DATE_RANGE_CONFIG,
      paramsByTableType: {
        loans: {
          request: 'getLoans',
          dataName: 'agreements',
          requestParam: 'contract_ref'
        },
        loan: {
          request: 'getLoans',
          dataName: 'agreements',
          requestParam: 'contract_ref'
        },
        accounts: {
          request: 'getAccounts',
          dataName: 'accounts',
          requestParam: 'account'
        },
        payment_for_balance_accounts: {
          request: 'getAccounts',
          dataName: 'account',
          requestParam: 'account',
          openTable: 'open_deposits_table',
          closedTable: 'closed_deposits_table',
          requestOpenTable: 'open',
          requestClosedTable: 'closed'
        },
        account: {
          request: 'getAccounts',
          dataName: 'accounts',
          requestParam: 'account'
        },
        accounts_tabs: {
          request: 'getAccounts',
          dataName: 'accounts',
          requestParam: 'account',
          openTable: 'open_accounts_table',
          closedTable: 'closed_accounts_table',
          requestOpenTable: 'open',
          requestClosedTable: 'closed'
        },
        credits: {
          request: 'getLoans',
          dataName: 'contract_refs',
          requestParam: 'contract_ref',
          openTable: 'open_credits_table',
          closedTable: 'closed_credits_table',
          requestOpenTable: 'openAgreements',
          requestClosedTable: 'closedAgreements'
        },
        terminals: {
          request: 'getTerminals',
          dataName: 'terminals',
          requestParam: 'terminal_id',
          openTable: 'open_table',
          closedTable: 'closed_table',
          requestOpenTable: 'open_terminals',
          requestClosedTable: 'closed_terminals'
        },
        cards: {
          request: 'getCards',
          dataName: 'pan',
          requestParam: 'pan',
          openTable: 'open_cards_table',
          closedTable: 'closed_cards_table',
          requestOpenTable: 'openCards',
          requestClosedTable: 'closedCards'
        },
        deposits: {
          request: 'getDeposits',
          dataName: 'account',
          requestParam: 'account',
          openTable: 'open_deposits_table',
          closedTable: 'closed_deposits_table',
          requestOpenTable: 'openDeposits',
          requestClosedTable: 'closedDeposits'
        },
        guarantees: {
          request: 'getLoans',
          dataName: 'agreements',
          requestParam: 'contract_ref'
        },
      },
      showTableData: true,
      isReverseTableData: false,
      paramForSortTable: '',
      defaultTabs: ['tab1', 'tab2'],
      certificatesOptions: {
        cloan_status: {
          hideCancelBtn: true
        },
        full_loan_repayment_certificate: {
          hideCancelBtn: true
        },
        bank_license: {
            hideCancelBtn: true
        },
        bank_limits: {
            hideCancelBtn: true
        },
        bank_liquidation: {
            hideCancelBtn: true
        },
        contravention_guarantee_certificate: {
            hideCancelBtn: true
        }
      },
      state: {
        language: uk,
        disabledDates: {
          to: new Date(1992, 0, 1),
          from: new Date(),
        },
      },
      dateValue: new Date(),
      customLabels: {
        order_asc: 'Від старих до нових',
        show_digital_signature: 'Так',
      }
    }
  },
  computed: {
    indeterminate() {
      return (!!(this.selectAccounts.length)) && (this.selectAccounts.length !== this.table && this.table.data);
    },
    datePeriod: {
      get() {
        return [this.dateStart, this.dateFinish]
      },
      set(value) {
        if (value[0] && value[0] !== null) {
          this.dateStart = value[0];
          delete this.errors.date_begin;
          this.requestData['date_begin'] = this.customFormatter(this.dateStart);
        } else if (this.elements.date_period) {
          Vue.set(this.errors, 'date_begin',this.elements.date_period?[this.elements.date_period.error]:['']);
        }
        if (value[1] && value[1] !== null) {
          this.dateFinish = value[1];
          delete this.errors.date_end;
          this.requestData['date_end'] = this.customFormatter(this.dateFinish);
        } else if (this.elements.date_period) {
          Vue.set(this.errors, 'date_end', this.elements.date_period?[this.elements.date_period.error]:['']);
        }
      }
    },
    date: {
      get() {
        return this.dateValue
      },
      set(value) {
        this.dateValue = this.customFormatter(value);
        this.requestData['date'] = this.customFormatter(value);
        delete this.errors['date'];
      }
    },
  },
  mounted() {
    RequestService.getInitData()
        .then(({data}) => {
          this.initData = data;
          this.setAdditionalRequestData(data);
        })
        .catch(() => {

        })
        .finally(() => {
          this.loading = false;
        });
  },
  methods: {
    getElementLabel(element) {
        return this.customLabels[element.name] || element.label;
    },
    getSelectOptions(element) {
        if (element.name === 'certificate_type') {
            const inquiries = element.inquiries?.list || [];
            const statements = element.statements?.list || [];
            return [...inquiries, ...statements];
        }
        return element.data || [];
    },
    setTableRequestParam(data) {
      this.selectAccounts = data;
    },
    changeTab(tab) {
      this.activeTab = tab;
      this.selectAccounts = [];
    },
    getElementDisplayForaAquiring() {
      if (this.requestData.certificate_type === 'acquiring_statement') {
        return this.elements.terminals ? this.elements.terminals.data.length > 0 : true;
      } else {
        return true;
      }
    },
    inputDeleteSpace: function(event) {
      event.target.value = event.target.value.trim()
    },
    /**
     * Формирование обьекта запроса доп полей
     */
    setAdditionalRequestData(data) {
      if (data.create_certificate && data.create_certificate.elements) {
        this.elements = data.create_certificate.elements;
        for (const element in data.create_certificate.elements) {
          if (Object.prototype.hasOwnProperty.call(data.create_certificate.elements, element)) {
            const elementData = data.create_certificate.elements[element];

            // Установка значений по умолчанию для обязательных чекбоксов
            if (elementData.type === 'checkbox') {
              this.requestData[element] = false;
            } else {
              this.requestData[element] = '';
            }
          }
        }
      }
    },
    /**
     *Получение названия кнопки для перехода в историю запросов
     * @returns {string|*|string}
     */
    getButtonLabel() {
      if (this.initData.elements && this.initData.elements.length) {
        const find = this.initData.elements.find(element => element.name === 'button_journal');

        return find ? find.label : '';
      }

      return '';
    },
    /**
     * Получение заголовка страницы
     * @returns {string|*|string}
     */
    getTitle() {
      if (this.initData.create_certificate) {

        return this.initData.create_certificate.title ? this.initData.create_certificate.title : '';
      }

      return '';
    },
    /**
     * Проверка данных/получение счетов
     * @param key
     * @param e
     */
    changeRequestData(key, e) {
      this.opacity = '0.75';
      delete this.errors[key];
      if (key === 'contractor_attribute') {
        if (e === 'account') {
          this.elementName = '260000000000';
        } else {
          this.elementName = '';
        }
        if (!e) {
          delete this.errors['contractor_attribute_value'];
          this.requestData.contractor_attribute_value = '';
        } else {
          this.inputUpdate(this.requestData.contractor_attribute_value, 'contractor_attribute_value');
        }
      }
      if (key === 'certificate_type') {
        this.accounts = [];
        this.elements = [];
        this.selectAccounts = [];
        this.requestData = {certificate_type: e};
        this.errors = {};
        this.elementName = '';
        this.datePeriod = []
        this.getAdditionElements();
      }
    },
    /**
     * Получение списка доп полей
     */
    getAdditionElements() {
      this.loading = true;
      RequestService.getAdditionElements(this.requestData)
          .then(({data}) => {
            this.elements = {...this.initData.create_certificate.elements, ...data};
            delete this.elements.request_ref;
            delete this.elements.response_ref;
            delete this.elements.result;
            delete this.elements.timestamp;
            this.table = null;
            this.tabs = null;
            this.checkIsTables();
            this.setDefaultElements(this.elements.language);
            this.setDefaultElements(this.elements.operation_type);
            this.setDefaultElements(this.elements.withStamp);
            this.setDefaultElements(this.elements.format);
            if (this.elements.date) {
              this.requestData.date = this.customFormatter(new Date());
            }
          })
          .catch(() => {
          })
          .finally(() => {
            this.loading = !!this.table;
          });
    },
    setDefaultElements(element) {
      if (element) {
        this.requestData[element.name] = element.data[0].value
      }
    },
    /**
     * Проверка на поле "account(s)"
     */
    checkIsTables() {
      for (const key in this.elements) {
        if (Object.prototype.hasOwnProperty.call(this.elements, key)) {
          if (this.elements[key].type === 'table') {
            this.table = this.elements[key];
            this.isCheckbox = this.elements[key].name === 'accounts' || this.elements[key].multiple;
            this.getTableData(this.elements[key].name);
          }
          if (this.elements[key].type === 'tabs') {
            this.tabs = this.elements[key];
            this.isCheckbox = this.elements[key].multiple;
            this.getTableData(this.elements[key].name, this.elements[key].type);
          }
        }
      }
    },
    checkLengthAccounts() {
      return !this.elements.account_table || this.selectAccounts.length > 0;
    },
    /**
     * Получение списка счетов
     */
    getTableData(name, type) {
      this.loading = true;
      RequestService[this.paramsByTableType[name].request](this.requestData)
          .then(({data}) => {
            if (type === 'tabs') {
              const tables = name === 'payment_for_balance_accounts' || name === 'accounts_tabs' ? data.accounts : data;
              this.setTabTableData(tables, name);
              if (this.table) this.table.data = data;
            } else {
              this.table.data = data[this.paramsByTableType[name].dataName].length ? data[this.paramsByTableType[name].dataName] : null;
            }
          })
          .catch((err) => {
            this.setTabTableData(null, name);
            if (err.errors && err.errors.message) {
              this.tabs.tab1[this.paramsByTableType[name].openTable].no_data = err.errors.message;
              this.tabs.tab2[this.paramsByTableType[name].closedTable].no_data_closed = err.errors.message;
            }
          })
          .finally(() => {
            this.loading = false;
            this.$forceUpdate();
          });
    },
    setTabTableData(data, name) {
      this.tabs.tab1[this.paramsByTableType[name].openTable].data = data ? data[this.paramsByTableType[name].requestOpenTable] : [];
      this.tabs.tab2[this.paramsByTableType[name].closedTable].data = data ? data[this.paramsByTableType[name].requestClosedTable] : [];
    },
    /**
     * Выбор всех счетов
     * @param checked
     */
    selectAllAccounts(checked) {
      this.selectAccounts = [];
      if (checked === 'all_selected') {
        this.selectAccounts = this.accounts.map(item => item.account);
      }
    },

    /**
     * Формирование обьекта для заказа
     */
    getSendData() {
      const data = {};
      for (const key in this.requestData) {
          data[key] = this.requestData[key];
      }

      // добавление значение неотмеченных обязательных чекбоксов
      for (const key in this.elements) {
        if (this.elements[key] &&
            this.elements[key].type === 'checkbox' &&
            this.elements[key].required === true) {
          if (data[key] === undefined) {
            data[key] = false;
          }
        }
      }

      if (this.selectAccounts && this.selectAccounts.length) {
        const param = this.table ? (this.paramsByTableType[this.table.name].requestParam + `${this.isCheckbox ? 's' : ''}`)
            : this.tabs.parameter;
        data[param] = this.selectAccounts;
      }
      return data;
    },
    processRequest() {
      if (this.elements.email_form) {
        this.$bvModal.show('email')
      } else {
        this.sendRequest();
      }
    },
    /**
     * Заказ справки
     */
    sendRequest() {
      this.loading = true;
      const send = this.getSendData();
      if (send.certificate_type === 'acquiring_statement' && send.terminal_id !== undefined) {
          send.terminals = send.terminal_id;
          delete send.terminal_id;
      }
      if (send.certificate_type === 'corporate_client_statement' || send.certificate_type === 'turnover_certificate') {
          send.accounts = Array.isArray(send.accounts) ? send.accounts : [send.accounts]
      }
      RequestService.getDocument(send)
          .then(({data}) => {
            if (data.link) {
              window.open(data.link);
            }
            if (data.message) {
              this.$toast.open({
                message: data.message,
                type: 'success',
              })
            }
            this.selectAccounts = [];
          })
          .catch(err => {
            if (err.errors) {
              this.errors = err.errors.errors;
            }
          })
          .finally(() => {
            this.loading = false;
            delete this.requestData['email'];
          });
    },
    /**
     * Отмена заказа справки
     */
    clearRequest() {
      this.selectAccounts = [];
    },
    /**
     * Проверка на наличие ошибки
     * @param key
     * @returns {boolean}
     */
    issetError(key) {
      if (key === 'date_period') {
        return Object.prototype.hasOwnProperty.call(this.errors, 'date_begin') ||
            Object.prototype.hasOwnProperty.call(this.errors, 'date_end');
      }
      return Object.prototype.hasOwnProperty.call(this.errors, key);
    },
    inputUpdate(value, key) {
      if (key === 'contractor_attribute_value' && (this.requestData['contractor_attribute'] === 'okpo' ||
          this.requestData['contractor_attribute'] === 'account')) {
        delete this.errors['contractor_attribute_value'];
        let maxLength = /^[0-9]{0,10}$/;
        let error = [this.elements.contractor_attribute_value.errors.okpo.max10];
        if (this.requestData['contractor_attribute'] === 'account') {
          maxLength = /^[0-9]{14}$/;
          error = [this.elements.contractor_attribute_value.errors.account.size14];
        }
        if (!maxLength.test(value)) {
          this.errors['contractor_attribute_value'] = error;
        }

      }
    },
    getDate() {
      return new Date();
    },
    customFormatter(date) {
      if (date) {
        return moment(date).format('YYYY-MM-DD');
      }
    },
    getDatePickerHeaderYear() {
      if (this.$refs.datepicker && this.$refs.datepicker.length) {
        return this.dateFormatter(this.$refs.datepicker[0].selectedDate, "YYYY")
      }
      return '-'
    },
    getDatePickerHeaderText() {
      if (this.$refs.datepicker && this.$refs.datepicker.length) {
        return this.dateFormatter(this.$refs.datepicker[0].selectedDate, "dddd D MMMM")
      }
      return '-'
    },
    dateFormatter(date, format) {
      return moment(date).local('uk').format(format);
    },
    setModalParam(parameter, value) {
      this.requestData[parameter] = value;
      this.sendRequest();
    },
    showButtons() {
      return ((this.requestData.certificate_type && !this.table && !this.tabs) || this.selectAccounts.length)
          && Object.entries(this.errors).length === 0 && this.getElementDisplayForaAquiring();
    }
  },
  watch: {
    selectAccounts(newValue) {
      this.all_accounts = (newValue.length === 1) ?
          'all_selected' : 'not_all_selected';
    },
  }
}